import dayjs from "dayjs";

/**
 * Group notifications by date ranges
 */
export const groupNotificationsByDate = (notifications, t) => {
    const today = dayjs().startOf("day");
    const yesterday = today.subtract(1, "day");
    const sevenDaysAgo = today.subtract(7, "day");

    const groups = {
        [t("notifications.TODAY")]: [],
        [t("notifications.YESTERDAY")]: [],
        [t("notifications.LAST_7_DAYS")]: [],
        [t("notifications.OLDER")]: [],
    };

    notifications.forEach((notification) => {
        const date = dayjs(notification.addedOn);

        if (date.isSame(today, "day")) {
            groups[t("notifications.TODAY")].push(notification);
        } else if (date.isSame(yesterday, "day")) {
            groups[t("notifications.YESTERDAY")].push(notification);
        } else if (date.isAfter(sevenDaysAgo)) {
            groups[t("notifications.LAST_7_DAYS")].push(notification);
        } else {
            groups[t("notifications.OLDER")].push(notification);
        }
    });

    // Remove empty groups
    Object.keys(groups).forEach(key => {
        if (groups[key].length === 0) delete groups[key];
    });

    return groups;
};